var Form = {};
Form.init = function () {
  $('input[type="checkbox"].custom-control-input').change(function () {
    if ($(this).prop('checked')) {
      $(this).removeClass('is-invalid');
    }
  });
  $(document).on('click', '.js-cart-link', function (e) {
    if (matchMedia('screen and (max-width: 991.98px)').matches) {
      e.preventDefault();
      e.stopPropagation();
      var _this = $(this);
      _this.closest('.js-cart-overlay').toggleClass('is-open');
      $('body').toggleClass('cart-mobile-open');
    }
  });
};
Form.init();


// WEBPACK FOOTER //
// ./scripts/components/form.js